import { PriceDetailAir, PriceDetailCruise, PriceDetailGeneric, PriceDetailPromo } from "./price-detail"
import { summon, AType } from "@silversea-ssc/functional-support"

const _PaxFlights = summon((F) =>
    F.interface(
        {
            outbound: PriceDetailAir(F),
            return: PriceDetailAir(F),
        },
        "PaxFlights",
    ),
)
export type PaxFlights = AType<typeof _PaxFlights>
export const PaxFlights = /* @__PURE__ */ Object.assign(_PaxFlights, {
    isIncluded: (x: PaxFlights): boolean => x.outbound.price.value === 0,
})

export const PaxPriceDetails = summon((F) =>
    F.interface(
        {
            cruise: PriceDetailCruise(F),
            flights: F.nullable(PaxFlights(F)),
            promotions: F.array(PriceDetailPromo(F)),
            others: F.array(PriceDetailGeneric(F)),
        },
        "PaxPriceDetails",
    ),
)
export type PaxPriceDetails = AType<typeof PaxPriceDetails>
